export const modelosDecursoPageSize = 10;
